<template>
    <div class="flex flex-col gap-2">
        <h1
            v-if="title"
            class="text-lg font-semibold text-card-foreground leading-none break-word"
        >
            {{ title }}
        </h1>
        <p
            v-if="description"
            class="text-sm text-muted-foreground leading-5"
        >
            {{ description }}
        </p>
    </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
    title?: string
    description?: string
    size?: 'md'
}>(), {
    size: 'md',
})
</script>
